<app-nav-banner *ngIf="isBanner" />
<header *ngLet="user$ | async as user" class="h-24 bg-white border-b border-slate-200/80">
  <div class="flex items-center w-full h-full max-w-screen-xl px-5 mx-auto sm:px-6 lg:px-8">
    <nav class="relative z-50 flex items-center justify-between w-full">
      <!-- Logo -->
      <div class="flex items-center shrink-0">
        <a aria-label="Home" class="flex items-center flex-shrink-0" href="/">
          <img alt="" class="w-auto h-8" src="/assets/logo.svg" />
        </a>
      </div>
      <!-- Desktop navigation links -->
      <div class="items-center hidden md:flex md:space-x-6 lg:space-x-8">
        <ng-container *ngFor="let item of links; index as i">
          <ng-container *ngIf="item.dropdown; else noDropdown">
            <div class="relative">
              <button
                (click)="onClickDropdown(i, $event)"
                [ngClass]="{
                  'text-slate-900': openedLinkIndex === i,
                  'text-slate-700 hover:text-slate-900': openedLinkIndex !== i,
                }"
                class="flex items-center font-medium duration-200 ease-in-out group"
                type="button">
                <span>{{ item.label | translate }}</span>
                <!-- Heroicon name: solid/chevron-down -->
                <svg
                  [ngClass]="{
                    'rotate-180 text-slate-900': openedLinkIndex === i,
                    'text-slate-600 group-hover:text-slate-800': openedLinkIndex !== i,
                  }"
                  class="w-5 h-5 ml-2 duration-300"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    clip-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    fill-rule="evenodd" />
                </svg>
              </button>
              <!-- Pages dropdown -->
              <div
                (clickOutside)="onClickOutsideDropdown()"
                *ngIf="openedLinkIndex === i"
                class="absolute right-0 z-20 mt-3 w-80 space-y-1 rounded-lg bg-white p-2.5 drop-shadow filter focus:outline-none outline-none">
                <a
                  *ngFor="let dropdown of item.dropdown"
                  [routerLink]="dropdown.url"
                  class="block py-3.5 px-5 font-medium rounded-md text-slate-700 transition duration-300 ease-in-out hover:bg-slate-50 hover:text-slate-900">
                  {{ dropdown.label | translate }}
                </a>
              </div>
            </div>
          </ng-container>
          <ng-template #noDropdown>
            <a
              [routerLink]="item.url"
              class="relative duration-200 font-semibold text-slate-900"
              routerLinkActive='after:absolute after:left-1/2 after:-bottom-2.5 after:h-0.5 after:w-4 after:-translate-x-1/2 after:rounded-full after:bg-slate-900 after:opacity-100 after:content-[""] '>
              {{ item.label | translate }}
            </a>
          </ng-template>
        </ng-container>
      </div>
      <div class="flex items-center">
        <div class="relative ml-4 lg:mr-2 flex items-center">
          <button (click)="onClickLang($event)" class="group relative h-9 w-9 rounded-full lg:flex">
            <img
              class="transition relative m-auto h-5 w-5 rounded-full ring-1 ring-gray-300"
              src="assets/flags/{{ currentLang }}.svg" />
          </button>
          <div
            (clickOutside)="isOpenLang = false"
            [class.hidden]="!isOpenLang"
            [class.visible]="isOpenLang"
            class="absolute top-full z-20 right-0 min-w-[220px] w-fit origin-top-right translate-y-1 scale-90 flex-col flex-wrap justify-end gap-6 rounded-2xl bg-white p-6 shadow-lg ring-1 ring-gray-900/5">
            <div class="text-gray-900">
              <ul class="space-y-5 text-base font-medium tracking-wide">
                <li *ngFor="let lang of availableLang" class="flex items-center">
                  <span
                    (click)="onChangeLang(lang)"
                    [class.text-primary]="currentLang === lang"
                    class="cursor-pointer inline-flex gap-3 transition hover:text-primary dark:hover:text-primaryLight">
                    <img
                      class="transistion relative m-auto ring-1 ring-gray-300 h-6 w-6 rounded-full"
                      src="assets/flags/{{ lang }}.svg" />
                    <span>{{ 'COMMON.' + lang | uppercase | translate }}</span></span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="hidden lg:flex items-center">
          <ng-container *ngIf="user; else noUser">
            <button
              (click)="onLogout()"
              class="relative hidden lg:flex flex-shrink-0 rounded-full bg-white p-1 text-red-500 hover:text-red-400 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2">
              <span class="absolute -inset-1.5"></span>
              <svg
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
            <a [routerLink]="['/', routesPath.dashboard]" class="hidden sm:block -m-1.5 p-1.5 ml-2">
              <img
                class="min-w-min h-8 w-8 rounded-full bg-gray-800"
                src="https://ui-avatars.com/api/?name={{ user.email[0] | titlecase }}+{{
                  user.email[1] | titlecase
                }}" />
            </a>
          </ng-container>
          <ng-template #noUser>
            <a
              [routerLink]="['/', routesPath['sign-in']]"
              class="mr-5 relative duration-200 after:absolute after:left-1/2 after:-bottom-2.5 after:h-0.5 after:w-4 after:-translate-x-1/2 after:rounded-full after:bg-slate-900 after:opacity-0 after:content-[&quot;&quot;] font-medium text-slate-700 hover:text-slate-900 hover:after:opacity-25">
              {{ 'COMMON.SIGN_IN' | translate }}
            </a>
            <a
              [routerLink]="['/', routesPath['sign-up']]"
              class="text-slate-900 shadow-sm shadow-sky-100/50 ring-1 ring-slate-100 hover:bg-slate-200/60 hover:shadow-sky-100/50 bg-slate-100/80 inline-flex items-center rounded-full gap-2.5 justify-center px-7 py-3 text-md font-semibold leading-none outline-offset-2 transition-all duration-200 ease-in-out active:transition-none">
              {{ 'COMMON.SIGN_UP' | translate }}
            </a>
          </ng-template>
        </div>

        <!-- Mobile menu button -->
        <div class="ml-4 md:hidden">
          <button
            (click)="isOpen = true"
            aria-label="Toggle Navigation"
            class="relative z-50 flex items-center justify-center p-3 transition duration-300 ease-in-out rounded-full shadow-sm cursor-pointer group bg-slate-100/80 shadow-sky-100/50 ring-1 ring-slate-900/5 hover:bg-slate-200/60 focus:outline-none md:hidden">
            <span class="relative h-3.5 w-4 transform transition duration-500 ease-in-out">
              <span
                [ngClass]="{
                  'top-0 left-0 w-full': !isOpen,
                  'top-1.5 left-1/2 w-0': isOpen,
                }"
                class="absolute block h-0.5 rotate-0 transform rounded-full bg-slate-700 opacity-100 transition-all duration-300 ease-in-out group-hover:bg-slate-900"></span>
              <span
                [ngClass]="{
                  'rotate-0': !isOpen,
                  'rotate-45': isOpen,
                }"
                class="absolute left-0 top-1.5 block h-0.5 w-full transform rounded-full bg-slate-700 opacity-100 transition-all duration-300 ease-in-out group-hover:bg-slate-900"></span>
              <span
                [ngClass]="{
                  'rotate-0': !isOpen,
                  'rotate-45': isOpen,
                }"
                class="absolute left-0 top-1.5 block h-0.5 w-full transform rounded-full bg-slate-700 opacity-100 transition-all duration-300 ease-in-out group-hover:bg-slate-900"></span>
              <span
                [ngClass]="{
                  'left-0 top-3 w-full': !isOpen,
                  'top-1.5 left-1/2 w-0': isOpen,
                }"
                class="absolute block h-0.5 rotate-0 transform rounded-full bg-slate-700 opacity-100 transition-all duration-300 ease-in-out group-hover:bg-slate-900"></span>
            </span>
          </button>
          <!-- Mobile menu container -->
          <div class="md:hidden">
            <!-- Background dark overlay when mobile menu is open -->
            <div *ngIf="isOpen" class="fixed inset-0 z-20 bg-opacity-50 bg-slate-900"></div>
            <!-- Mobile menu popover -->
            <div
              *ngIf="isOpen"
              class="absolute inset-x-0 z-30 px-6 mt-4 overflow-hidden origin-top shadow-xl top-full rounded-2xl bg-slate-50 py-7 shadow-sky-100/40 ring-1 ring-slate-900/5">
              <div>
                <!-- Mobile menu links -->
                <div class="flex flex-col space-y-4">
                  <ng-container *ngFor="let item of links; index as i">
                    <ng-container *ngIf="item.dropdown; else noDropdown">
                      <div class="relative">
                        <button
                          (click)="openedLinkIndex = i"
                          [ngClass]="{
                            'text-slate-900': openedLinkIndex === i,
                            'text-slate-700 hover:text-slate-900': openedLinkIndex !== i,
                          }"
                          class="flex items-center w-full gap-2 text-base font-semibold duration-200 ease-in-out group">
                          <span>{{ item.label | translate }}</span>
                          <svg
                            [ngClass]="{
                              'rotate-90 text-slate-900': openedLinkIndex === i,
                              'text-slate-700 group-hover:text-slate-900': openedLinkIndex !== i,
                            }"
                            class="w-5 h-5 duration-300"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              clip-rule="evenodd"
                              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                              fill-rule="evenodd" />
                          </svg>
                        </button>
                        <ul *ngIf="openedLinkIndex === i" class="z-20 px-3 space-y-4">
                          <li *ngFor="let dropdown of item.dropdown" class="mt-4">
                            <a
                              [routerLink]="dropdown.url"
                              class="block font-medium transition duration-200 ease-in-out text-md text-slate-700 hover:text-slate-900">
                              {{ dropdown.label | translate }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                    <ng-template #noDropdown>
                      <a
                        [routerLink]="item.url"
                        class="block text-base font-semibold duration-200 text-slate-700 hover:text-slate-900">
                        {{ item.label | translate }}
                      </a>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="user; else noUser">
                    <span
                      [routerLink]="['/', routesPath['dashboard']]"
                      class="text-slate-700 block font-medium transition duration-200 ease-in-out text-md hover:text-slate-900">
                      {{ 'COMMON.DASHBOARD' | translate }}
                    </span>
                    <span
                      (click)="onLogout()"
                      class="text-red-500 block font-medium transition duration-200 ease-in-out text-md hover:text-slate-900">
                      {{ 'COMMON.LOGOUT' | translate }}
                    </span>
                  </ng-container>
                  <ng-template #noUser>
                    <a
                      [routerLink]="['/', routesPath['sign-in']]"
                      class="text-slate-900 shadow-sm shadow-sky-100/50 ring-1 ring-slate-100 hover:bg-slate-200/60 hover:shadow-sky-100/50 bg-slate-100/80 inline-flex items-center rounded-full gap-2.5 justify-center px-7 py-3 text-md font-semibold leading-none outline-offset-2 transition-all duration-200 ease-in-out active:transition-none">
                      {{ 'COMMON.SIGN_IN' | translate }}
                    </a>
                    <a
                      [routerLink]="['/', routesPath['sign-up']]"
                      class="text-slate-900 shadow-sm shadow-sky-100/50 ring-1 ring-slate-100 hover:bg-slate-200/60 hover:shadow-sky-100/50 bg-slate-100/80 inline-flex items-center rounded-full gap-2.5 justify-center px-7 py-3 text-md font-semibold leading-none outline-offset-2 transition-all duration-200 ease-in-out active:transition-none">
                      {{ 'COMMON.SIGN_UP' | translate }}
                    </a>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</header>
